export default {
  peopleSelectionHeader: '01072019-095653-4275', // How many people?
  peopleSelectionAriaGroup: '00000000-000000-0000', // People selector
  peopleSelectionAriaDecrease: '00000000-000000-0000', // Decrease people
  peopleSelectionAriaIncrease: '00000000-000000-0000', // Increase people
  peopleSelectionAriaCount: '00000000-000000-0000', // People count
};
